export default __webpack_public_path__ + "static/media/eraser.fb6de57d.png";